export default __webpack_public_path__ + "static/media/logo_banmedica.bae2f0a0.png";